function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import flat from "flat";
import { rem } from "./utils/rem.js";
export var deepFontSizeObject = {
    heading: {
        h1: {
            base: rem(42),
            tablet: rem(54),
            desktop: rem(72)
        },
        h2: {
            base: rem(32),
            desktop: rem(52),
            "desktop-s": rem(38)
        },
        h3: {
            base: rem(20),
            desktop: rem(26),
            "desktop-s": rem(22)
        },
        h4: {
            base: rem(18)
        }
    },
    body: {
        xxlarge: rem(28),
        xlarge: rem(24),
        large: rem(20),
        medium: rem(18),
        base: rem(16),
        small: rem(14),
        xSmall: rem(12)
    },
    link: {
        medium: rem(18),
        base: rem(16),
        small: rem(14)
    },
    label: {
        base: rem(11)
    },
    button: {
        base: rem(14),
        calculate: rem(15)
    },
    navigation: {
        lg: rem(18),
        base: rem(14),
        small: rem(10)
    }
};
export var baseFontSize = flat(deepFontSizeObject, {
    delimiter: "-"
});
export var fontSize = _object_spread({}, baseFontSize);

//# sourceMappingURL=fontSize.js.map